import _classCallCheck from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.

/** @private */
export var AbortController = /*#__PURE__*/function () {
  function AbortController() {
    _classCallCheck(this, AbortController);

    this._isAborted = false;
    this.onabort = null;
  }

  _createClass(AbortController, [{
    key: "abort",
    value: function abort() {
      if (!this._isAborted) {
        this._isAborted = true;

        if (this.onabort) {
          this.onabort();
        }
      }
    }
  }, {
    key: "signal",
    get: function get() {
      return this;
    }
  }, {
    key: "aborted",
    get: function get() {
      return this._isAborted;
    }
  }]);

  return AbortController;
}();